/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

import React from 'react';
import { useTheme } from '../../theme/ThemeContext';

const items = [
    {
        title: 'BaaS Core',
        desc: 'Headless Django backend with secure, scalable PostgreSQL storage.',
        icon: 'bi-database'
    },
    {
        title: 'Studio',
        desc: 'Visual builder to define models, forms, and permission rules.',
        icon: 'bi-window-sidebar'
    },
    {
        title: 'Client Runtime',
        desc: 'Instant React frontend that adapts to your defined schema.',
        icon: 'bi-code-slash'
    },
    {
        title: 'File Store',
        desc: 'Dedicated async file storage and management system.',
        icon: 'bi-folder'
    }
];

function PlatformSection() {
    const { theme } = useTheme();

    return (
        <section id="about" className="py-5" style={{ background: '#f8f9fa' }}>
            <div className="container py-5">
                <div className="row align-items-center mb-5">
                    <div className="col-lg-6 mb-4 mb-lg-0">
                        <h6 className="fw-bold mb-2" style={{ color: theme.secondary, letterSpacing: '2px', textTransform: 'uppercase' }}>
                            Arcee Platform
                        </h6>
                        <h2 className="fw-bold display-4 mb-4" style={{ color: theme.primary }}>
                            Enterprise Control.<br />
                            <span className="text-muted">No-Code Speed.</span>
                        </h2>
                    </div>
                    <div className="col-lg-6">
                        <p className="lead text-secondary">
                            Most no-code tools are complex. <span className="fw-bold">arcee is simplified nirvana.</span> We decoupled the backend from the frontend to give you true architectural freedom. Design your data models in our Studio, and we provision a production-ready React frontend, PostgreSQL database and secure SaaS APIs instantly.
                        </p>
                    </div>
                </div>

                <div className="row g-4">
                    {items.map((item, index) => (
                        <div className="col-md-3" key={index}>
                            <div
                                className="h-100 p-4 bg-white rounded-4 shadow-sm position-relative overflow-hidden"
                                style={{ transition: 'transform 0.3s ease', borderTop: `4px solid ${theme.primary}` }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-5px)';
                                    e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = 'none';
                                }}
                            >
                                <div
                                    className="mb-3 d-inline-flex align-items-center justify-content-center rounded-3"
                                    style={{ width: 48, height: 48, background: `${theme.primary}10`, color: theme.primary }}
                                >
                                    <i className={`bi ${item.icon} fs-4`}></i>
                                </div>
                                <h5 className="fw-bold mb-2">{item.title}</h5>
                                <p className="small text-muted mb-0">{item.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default PlatformSection;
